module.exports = __webpack_public_path__ + "img/riscodeperder.e6e3e7a9.png";